import React from 'react';

const Pagination = ({ totalItems, itemsPerPage, currentPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) return null;

  const maxVisible = 10;
  let startPage = 1;
  let endPage = totalPages;

  if (totalPages > maxVisible) {
    const half = Math.floor(maxVisible / 2);
    startPage = currentPage - half;
    endPage = currentPage + half;

    if (startPage < 1) {
      startPage = 1;
      endPage = maxVisible;
    }

    if (endPage > totalPages) {
      endPage = totalPages;
      startPage = totalPages - maxVisible + 1;
    }
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  const buttonStyle = (pageNumber) => ({
    marginRight: '5px',
    width: '30px',
    fontWeight: '600',
    fontSize: '10pt',
    background:
      currentPage === pageNumber
        ? 'rgb(1, 64, 180)'
        : 'rgb(41, 116, 255)',
    color: 'white'
  });

  return (
    <div className="d-flex flex-wrap">

      {/* First page */}
      {startPage > 1 && (
        <>
          <button
            onClick={() => onPageChange(1)}
            className="btn btn-login p-0 py-0 mb-2"
            style={buttonStyle(1)}
          >
            1
          </button>
          {startPage > 2 && <span className="me-1">...</span>}
        </>
      )}

      {/* Middle pages */}
      {pages.map(page => (
        <button
          key={page}
          onClick={() => onPageChange(page)}
          className="btn btn-login p-0 py-0 mb-2"
          style={buttonStyle(page)}
        >
          {page}
        </button>
      ))}

      {/* Last page */}
      {endPage < totalPages && (
        <>
          {endPage < totalPages - 1 && <span className="me-1">...</span>}
          <button
            onClick={() => onPageChange(totalPages)}
            className="btn btn-login p-0 py-0 mb-2"
            style={buttonStyle(totalPages)}
          >
            {totalPages}
          </button>
        </>
      )}

    </div>
  );
};

export default Pagination;
